// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__YnMDi","title":"Images45_title__HxyQG","images":"Images45_images__3BUKg"};